import { render } from "./FormContainer.vue?vue&type=template&id=41c02630"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"
script.render = render

export default script